// File: cgp.module.ts
// Author: Joseph M Diaz
// Date: 6/2/2017
// Desc: CGP module
// Other Contributors:

import { NgModule } from '@angular/core';

/**
 * Common Modules
 */
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * Kendo UI Modules
 */
import { DialogModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { TabStripModule, LayoutModule } from '@progress/kendo-angular-layout';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { EditorModule } from '@progress/kendo-angular-editor';
import { UploadModule } from '@progress/kendo-angular-upload';

/**
 * CGP Modules
 */
import { CgpAlertDialogModule } from './cgp-alert-dialog/cgp-alert-dialog.module';
import { CgpSidenavModule } from './cgp-sidenav/cgp-sidenav.module';
import { CgpConfirmationDialogModule } from './cgp-confirmation-dialog/cgp-confirmation-dialog.module';
import { CgpBreadcrumbsModule } from './cgp-breadcrumbs/cgp-breadcrumbs.module';
import { CgpSnackbarModule } from './cgp-snackbar/cgp-snackbar.module';
import { CgpAppBarModule } from './cgp-app-bar/cgp-app-bar.module';
import { CgpIdleModule } from './cgp-idle/cgp-idle.module';
import { CgpComponentBrowserModule } from './cgp-component-browser/cgp-component-browser.module';
import { CgpCheckAllModule } from './cgp-check-all/cgp-check-all.module';
import { CgpAppCardModule } from './cgp-app-card/cgp-app-card.module';
import { CgpNotificationMenuModule } from './cgp-notification-menu/cgp-notification-menu.module';
import { CgpFooterComponent } from './cgp-footer/cgp-footer.component';
import { CgpUserProfileDialogModule } from './cgp-user-profile-dialog/cgp-user-profile-dialog.module';
import { CgpApiService } from '../../../src/modules/cgp-api';
import { CgpPanelModule } from './cgp-panel/cgp-panel.module';

/**
 * Common Pipes
 */
import { PipesModule } from './pipes/pipes.module';

/**
 * Services
 */
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { AuthGuard } from '../auth.guard';
import { DataGridComponent } from './data-grid/data-grid.component';
import { DataGridModule } from './data-grid/data-grid.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        LayoutModule,
        PipesModule,
        DataGridModule,
        CgpAlertDialogModule,
        CgpSidenavModule,
        CgpConfirmationDialogModule,
        CgpBreadcrumbsModule,
        CgpSnackbarModule,
        CgpAppBarModule,
        CgpIdleModule,
        CgpComponentBrowserModule,
        CgpCheckAllModule,
        CgpAppCardModule,
        CgpNotificationMenuModule,
    ],
    declarations: [
        CgpFooterComponent,
        LoadingSpinnerComponent,
    ],
    providers: [
        AuthGuard,
        CgpApiService
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        GridModule,
        ExcelModule,
        ButtonGroupModule,
        ButtonsModule,
        TabStripModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        SwitchModule,
        CgpAlertDialogModule,
        NumericTextBoxModule,
        DateInputsModule,
        PipesModule,
        DataGridComponent,
        SchedulerModule,
        EditorModule,
        UploadModule,
        CgpConfirmationDialogModule,
        CgpUserProfileDialogModule,
        CgpBreadcrumbsModule,
        CgpSnackbarModule,
        CgpAppBarModule,
        CgpSidenavModule,
        CgpFooterComponent,
        CgpComponentBrowserModule,
        CgpCheckAllModule,
        CgpAppCardModule,
        CgpNotificationMenuModule,
        CgpPanelModule,
        DataGridModule
    ]
})
export class CgpModule { }
